module.exports = __webpack_public_path__ + "img/tmb.145d3150.png";